import React, { useContext, useMemo } from "react";
import BaseButton from "../../../../components/BaseButton";
import { useTranslation } from "react-i18next";
import WomanFace from "../../../../assets/images/woman_face.png";
import ManFace from "../../../../assets/images/man_face.png";
import useCurrentUserData from "../../../../hooks/useCurrentUserData";
import useCurrentGame from "../../../../hooks/useCurrentGame";
import Game from "../../../../store/Game";
import { useLocation, useNavigate } from "react-router-dom";
import {
  SOCKET_EVENTS,
  SocketContext,
} from "../../../../components/SocketProvider";
import {
  INSIGHT_FORM_STATUSES,
  NOTIFY_MODAL_TYPES,
} from "../../../../utils/constants";
import "./style.scss";
import BaseIcon from "../../../../components/BaseIcon";
import ROUTES from "../../../../utils/routes";
import config from "../../../../config";

const genderImagesDict = {
  male: ManFace,
  female: WomanFace,
};

export default function QuestionnaireItem({
  formData,
  isBlock1,
  isBlock2,
  isBlock3,
  isBlock4,
  isBlock5,
}) {
  const { sendEvent } = useContext(SocketContext);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { getUserData } = useCurrentUserData();
  const location = useLocation();
  const { getCurrentGame } = useCurrentGame();

  // когда показывать кнопку Смотреть

  const userQuestion = useMemo(() => {
    const user = getUserData();
    return formData.find((form) => form.userId === user.id);
  }, [formData]);

  const partnerQuestion = useMemo(() => {
    const game = getCurrentGame() || Game.game;
    if (!game?.partner) return null;
    return formData.find((form) => form.userId === game.partner.id);
  }, [formData]);

  const detectGenderFace = (form) => {
    return genderImagesDict[form.user.gender];
  };
  const getQuestion = () => {
    const user = getUserData();
    const questionData = formData[0];
    // индивидуальная (пустая) анкета: заголовок = введённое название (карточки нет)
    if (questionData.formType === "BLANK" || !questionData.question) {
      // 28.09: название берём из первой строки пары, где оно есть (сначала своя).
      // Раньше брали formData[0] — после сортировки по полу это всегда мужская
      // строка, и у автора-женщины показывалась пустая партнёрская (бэк клал
      // тему только автору) — под картинками в «Заполни анкету…» было пусто.
      const titled = [
        formData.find((form) => form.userId === user.id),
        ...formData,
      ].find((form) => form?.customTitle);
      return titled?.customTitle || "";
    }
    const genderSign = user.gender.slice(0, 1);
    const language = i18n.language;

    return questionData.question[`${genderSign}_${language}`];
  };
  const rejectQuestion = () => {
    const user = getUserData();
    const game = getCurrentGame() || Game.game;
    const question = formData.find((form) => form.userId === user.id);
    sendEvent(SOCKET_EVENTS.SEND_INSIGHT_MESSAGE, {
      questionId: question.questionId,
      pairKey: question.pairKey ?? null,
      room: game.id,
      message: "FuCK",
      recipientId: game.partner.id,
      senderId: user.id,
      status: INSIGHT_FORM_STATUSES.REJECTED,
      typeNotifyModal: NOTIFY_MODAL_TYPES.NOTIFY_PARTNER,
    });
    sendEvent(SOCKET_EVENTS.GET_BY_GAME, {
      gameId: game.id,
    });
  };

  const shareQuestionResult = () => {
    const user = getUserData();
    const game = getCurrentGame() || Game.game;
    const question = formData.find((form) => form.userId === user.id);
    sendEvent(SOCKET_EVENTS.SEND_INSIGHT_MESSAGE, {
      questionId: question.questionId,
      pairKey: question.pairKey ?? null,
      room: game.id,
      message: "FuCK",
      recipientId: game.partner.id,
      senderId: user.id,
      typeNotifyModal: NOTIFY_MODAL_TYPES.NOTIFY_PARTNER,
      status: INSIGHT_FORM_STATUSES.CAN_WATCH,
    });
    sendEvent(SOCKET_EVENTS.GET_BY_GAME, {
      gameId: game.id,
    });
  };

  const goToFillIn = (FnRoute = ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE) => {
    const user = getUserData();
    const game = getCurrentGame() || Game.game;
    const question = formData.find((form) => form.userId === user.id);

    if (!question.isViewed && game.partner) {
      sendEvent(SOCKET_EVENTS.ON_VIEW, {
        questionId: question.questionId,
        // BLANK без questionId помечается просмотренной по pairKey — иначе бэк
        // пометил бы произвольную BLANK-анкету юзера (как reject/share ниже)
        pairKey: question.pairKey ?? null,
        room: game.id,
        recipientId: game.partner.id,
        senderId: user.id,
        isViewed: true,
      });
    }
    navigate(FnRoute(userQuestion.id), {
      state: {
        formId: userQuestion.id,
        from: location.pathname,
      },
    });
  };

  const genderNoParthner = useMemo(() => {
    return userQuestion.user.gender === "female" ? "male" : "female";
  }, [userQuestion]);

  return (
    <div className="questionnaire-container">
      <div className="questionnaire-container__cards-wrap">
        {/* Бейдж уведомления — ВНЕ .__cards (у которого overflow:hidden для клипа
            «лиц-бабочек»), иначе отрицательный офсет бейджа полностью срезался. */}
        {(isBlock1 ||
          isBlock3 ||
          isBlock4 ||
          (isBlock5 &&
            partnerQuestion?.status === INSIGHT_FORM_STATUSES.CAN_WATCH)) &&
          !userQuestion.isViewed && (
            <div className="questionnaire-container__notification-item">
              <BaseIcon name="notif_voskl_sign" />
            </div>
          )}
        <div className="questionnaire-container__cards">
          {/* 28.09: сортируем копию — .sort() на месте мутировал массив из стейта
              списка анкет (formData[0] менялся после первого рендера) */}
          {[...formData]
            .sort((a, b) => {
              const aGender = a.user?.gender || "";
              const bGender = b.user?.gender || "";

              if (aGender === "female" && bGender !== "female") return 1;
              if (bGender === "female" && aGender !== "female") return -1;
              return 0;
            })
            .map((form) => {
              return (
                <div key={form.id}>
                  <div
                    onClick={() =>
                      isBlock4
                        ? goToFillIn(
                            ROUTES.HISTORY_INSIGHT_QUESTIONNAIRE_FORM_PAGE
                          )
                        : null
                    }
                    style={{
                      cursor:
                        isBlock4 && form.insightFormAnswers.length
                          ? "pointer"
                          : "initial",
                      filter: `grayscale(${
                        form.insightFormAnswers.length || form.isCreated ? 0 : 1
                      })`,
                    }}
                    className="questionnaire-container__card"
                  >
                    <img
                      className={`questionnaire-container__face questionnaire-container__face-${
                        form.user ? form.user.gender : genderNoParthner
                      }`}
                      src={
                        form.user
                          ? detectGenderFace(form)
                          : genderImagesDict[genderNoParthner]
                      }
                      alt=""
                    />
                    {form.question ? (
                      <img
                        src={`${config.staticApiUrl}${form.question.cardUrl}`}
                        alt="card"
                      />
                    ) : (
                      // BLANK-анкета: карточки нет (question=null) — пустая тёмная
                      // карточка в пропорциях фото-карточек; картинку дают большие
                      // «лица-бабочки» поверх (absolute), внутренняя бабочка их
                      // дублировала; название — под карточками (card-name)
                      <div className="questionnaire-container__blank-card" />
                    )}
                  </div>
                </div>
              );
            })}
        </div>
        <div className="questionnaire-container__card-name">
          {getQuestion()}
        </div>
      </div>
      <div className="questionnaire-container__actions">
        {isBlock1 ? (
          <>
            <BaseButton
              onClick={() => goToFillIn()}
              className="questionnaire-container__action"
            >
              {t("insight_form_page.fill_in")}
            </BaseButton>
            <BaseButton
              onClick={rejectQuestion}
              unfilled
              className="questionnaire-container__action"
            >
              {t("insight_form_page.reject")}
            </BaseButton>
          </>
        ) : null}
        {isBlock2 ? (
          userQuestion?.insightFormAnswers.length > 0 ? (
            <BaseButton
              unfilledGray
              className="questionnaire-container__action"
            >
              {t("insight_form_page.was_sent")}
            </BaseButton>
          ) : (
            <BaseButton
              onClick={() => goToFillIn()}
              className="questionnaire-container__action"
            >
              {t("insight_form_page.fill_in")}
            </BaseButton>
          )
        ) : null}
        {isBlock3 ? (
          <BaseButton
            gradientWrapperCls={
              "questionnaire-container__action-gradient-wrapper"
            }
            unfilledGradient={userQuestion.isViewed}
            className="questionnaire-container__action"
            onClick={() =>
              goToFillIn(ROUTES.HISTORY_INSIGHT_QUESTIONNAIRE_FORM_PAGE)
            }
          >
            {t("insight_form_page.watch")}
          </BaseButton>
        ) : null}
        {isBlock4 ? (
          userQuestion?.status === INSIGHT_FORM_STATUSES.CAN_WATCH ? (
            <BaseButton
              unfilledGray
              className="questionnaire-container__action"
            >
              {t("insight_form_page.was_sent")}
            </BaseButton>
          ) : (
            <BaseButton
              onClick={() => shareQuestionResult()}
              className="questionnaire-container__action"
            >
              {t("insight_form_page.share")}
            </BaseButton>
          )
        ) : null}
        {isBlock5 ? (
          <>
            {partnerQuestion.status === INSIGHT_FORM_STATUSES.CAN_WATCH ? (
              <BaseButton
                unfilledGradient={userQuestion.isViewed}
                gradientWrapperCls={
                  "questionnaire-container__action-gradient-wrapper"
                }
                className="questionnaire-container__action"
                onClick={() => {
                  goToFillIn(ROUTES.HISTORY_INSIGHT_QUESTIONNAIRE_FORM_PAGE);
                }}
              >
                {t("insight_form_page.watch")}
              </BaseButton>
            ) : null}
            <BaseButton
              gradientWrapperCls={
                "questionnaire-container__action-gradient-wrapper"
              }
              unfilledGradient={!userQuestion.isViewed}
              onClick={() => goToFillIn()}
              className="questionnaire-container__action"
            >
              {t("insight_form_page.fill_in")}
            </BaseButton>
          </>
        ) : null}
      </div>
    </div>
  );
}
